import { useNavigate, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import CreatePostForm from './components/CreatePostForm';

function CreatePost() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="py-8">
        <CreatePostForm
          onSuccess={post => navigate('/', { state: { message: 'Post created!', newPost: post } })}
          onClose={() => navigate(-1)}
          editPost={location.state?.post}
        />
      </div>
    </div>
  );
}

export default CreatePost;
